import { httpService } from "./AxiosInstance";

export const uploadFile = (formData: FormData) => {
  return httpService.post("/asset/upload", formData);
};
